class QuickSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // eslint-disable-next-line no-undef
    graphenehc.autocomplete({
      input_selector: "[data-quick-search-el='input']",
      page_context: { currency_id: window.Shopify.country },
      dropdown_selector: '[data-graphene-hc-el="original"]',
      position () {},
      after_load: () => {
        const originalEl = document.querySelector(
          '[data-graphene-hc-el="graphene-quicksearch"]',
        )
        const quickSearchEl = document.querySelector(
          '[data-graphene-hc-el="quicksearch"]',
        )

        quickSearchEl.innerHTML = originalEl.innerHTML
        originalEl.innerHTML = ''

        const homeEl = document.querySelector('[data-graphene-hc-el="home"]')
        const categoriesEl = document.querySelector(
          '[data-graphene-hc-el="categories"]',
        )

        if (!homeEl || !categoriesEl) return

        homeEl.innerHTML = categoriesEl.innerHTML
      },
      show () {
        document
          .querySelector('[data-graphene-hc-el="quicksearch"]')
          .setAttribute('aria-hidden', false)
        document
          .querySelector('quick-search')
          .classList.toggle('hd-Search-active', true)
      },
      hide () {
        document
          .querySelector('[data-graphene-hc-el="quicksearch"]')
          .setAttribute('aria-hidden', true)
        document
          .querySelector('quick-search')
          .classList.toggle('hd-Search-active', false)
      },
    })
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrigger = this.handleTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.listeners.add(
      this.externalEls.trigger.element,
      'click',
      this.handleTrigger,
    )
    this.listeners.add(this.els.close.element, 'click', this.handleClose)

    document.addEventListener('keyup', this.handleEscapePress.bind(this))
  }

  handleEscapePress (event) {
    if (event.code?.toUpperCase() !== 'ESCAPE') return

    document
      .querySelector('[data-graphene-hc-el="quicksearch"]')
      .setAttribute('aria-hidden', true)
    this.classList.toggle('hd-Search-active', false)
  }

  handleTrigger () {
    // Align temp input element approximately where the input element is
    // so the cursor doesn't jump around
    const tempInputEl = document.createElement('input')
    tempInputEl.style.position = 'absolute'
    tempInputEl.style.top = `${this.els.input.element.offsetTop + 7}px`
    tempInputEl.style.left = `${this.els.input.element.offsetLeft}px`
    tempInputEl.style.height = 0
    tempInputEl.style.opacity = 0
    // Put this temp element as a child of the page <body> and focus on it
    document.body.appendChild(tempInputEl)
    tempInputEl.focus()

    // The keyboard is open. Now do a delayed focus on the target element
    window.setTimeout(() => {
      document.body.classList.toggle('util-SiteOverflowed', true)
      this.classList.toggle('hd-Search-active', true)

      this.els.input.element.focus()
      this.els.input.element.click()
      // Remove the temp element
      document.body.removeChild(tempInputEl)
    }, 500)
  }

  handleClose () {
    this.classList.toggle('hd-Search-active', false)
    document.body.classList.toggle('util-SiteOverflowed', false)
  }
}

if (!customElements.get('quick-search')) {
  customElements.define('quick-search', QuickSearch)
}
